(function () {
  var LIMITS = [
    { match: 'Engraving - Phone number', maxLength: 16, message: 'Max one phone number' },
  ];

  function applyLimit(input, limit) {
    if (input.dataset.gpoCharLimitApplied) return;
    input.dataset.gpoCharLimitApplied = 'true';
    input.setAttribute('maxlength', String(limit.maxLength));

    var warning = document.createElement('div');
    warning.className = 'gpo-char-warning';
    warning.textContent = limit.message;
    var wrap = input.closest('.gpo-input-wrap') || input.parentElement;
    wrap.insertAdjacentElement('afterend', warning);

    input.addEventListener('input', function () {
      warning.classList.toggle('gpo-char-warning--visible', input.value.length >= limit.maxLength);
    });
  }

  function scan(root) {
    LIMITS.forEach(function (limit) {
      var inputs = root.querySelectorAll('input.gpo-input[name^="' + limit.match + '"]');
      inputs.forEach(function (input) {
        applyLimit(input, limit);
      });
    });
  }

  scan(document);

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('input.gpo-input')) {
          scan(node.parentElement || document);
        } else if (node.querySelectorAll) {
          scan(node);
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
